export default __webpack_public_path__ + "static/media/loading.84852f0f.gif";